import { Tab } from "./Tab";
import { Season } from "./Season";
import { VideoExtensionType } from "../components/VideoPlayer";

export enum CarouselFileType {
  Image,
  Video,
}

export type CarouselFile = {
  fileType: CarouselFileType;
  path: string;
  extensionType?: VideoExtensionType;
  smallPath?: string;
  poster?: string;
  smallPoster?: string;
  videoLength?: number;
  autoPlay?: boolean;
  loop?: boolean;
  category?: Tab;
  /**
   * Show the "Shop Now" overlay button, pointing at whatever the catalog says
   * the primary shoppable domain is. Prefer this over `domainName` — it can't
   * go stale when the category is renamed in Square.
   */
  showShopButton?: boolean;
  /** Overrides `showShopButton`'s destination with a specific domain. */
  domainName?: string;
  season?: Season;
  className?: string;
  smallClassName?: string;
  interval?: number;
};
